/**
 * Stage constructor
 * side parameter allows to set which side of stage should be displayed :
 * - left
 * - right
 * - both : if not set, or set to "" or null
 * @constructor shared.stage.Stage
 */
 fx.ns("shared.stage", class Stage extends fx.Component 
 {    
	 constructor(page, model, componentFactory, side, preview)
	 {
		 super(page);
		 
		 if (!componentFactory)
			 componentFactory = shared.stage.ComponentFactory;
		 
		 this._model = model;
		 this._displayedSide = side;
		 this._preview = preview;
		 this._factory = new componentFactory();
 
		 this._loaded = false;
	 }
 
	 /******************* Getters *******************/
     
	 get loaded()
	 {
		 return this._loaded;
	 }
 
	 get preview()
	 {
		 return this._preview;
	 }
 
	 get single()
	 {
		 return !!this._displayedSide;
	 }
 
	 get side()
	 {
		 return this._displayedSide;
	 }
 
	 set side(val)
	 {
		 this._displayedSide = val;
	 }
	 
	 get backgrounds() 
	 {
		 let childs = this.getChilds();
		 let bg = [];
		 for (let i = 0; i < childs.length; i++)
			 if (childs[i] instanceof shared.stage.components.Background)
				 bg.push( childs[i] );
			 
		 return bg;
	 }
	 
	 get model()
	 {
		 return this._model;
	 }
 
	 set model(val)
	 {
		 this._model = val;
	 }
 
	 get visibleSurface()
	 {
		 if (!this._visibleSurface && this.displayedSide == "left")
			 return {x : 0, width : this._realWidth};
			 
		 return this._visibleSurface;
	 }
 
	 set visibleSurface(val)
	 {
		 this._visibleSurface = val;
	 }
 
	 get pagination()
	 {
		 let childs = this.getChilds();
		 let pagination = [];
		 for(let i = 0 ; i < childs.length; i++)
		 {
			 if (childs[i] instanceof shared.stage.components.Pagination)
			 {
				pagination.push(childs[i]);
			 }
		 }
		 return pagination;
	 }
 
	 get sliceText()
	 {
		 let childs = this.getChilds();
		 let sliceText;
		 for(let i = 0 ; i < childs.length; i++)
		 {
			 if (childs[i] instanceof shared.stage.components.Text && childs[i].data.content_type == "slice-text")
			 {
				 sliceText = childs[i];
				 break;
			 }
		 }
		 return sliceText;
	 }
 
 
	 onReady()
	 {
		 super.onReady();
 
         // TODO : is this this used
		 this.on("scroll", this.onScroll);
	 }
 	 
	 onScroll()
	 {
		 this.node.scrollTop = 0;
	 }

     /********************* functions **********************/

     updateScale()
	 {
		 let childs = this.getChilds();
		 for (let i = 0; i < childs.length; i++)
           childs.getItemAt(i).refresh();
	 }
     
	 load(page, side)
	 {
		 if (side !== undefined)
			 this.displayedSide = side;
 
		 this.removeAllChild(true);
 
		 if (page)
			 this.data = page;
 
		 if (this.data)
		 {
			 // sort components so background is at the end
			 if (this.data && this.data.components)
			 {
				 let components = this.data.sortedComponents;
				 let i = 0;
				 while(i < components.length)
					 this.addComponent(components[i++], true);
			 }
		 }
 
		 this._loaded = true;
		 
         this._updateCommands();
	 }
 
	 unload()
	 {
		 this.removeAllChild( true );
		 this._loaded = false;
	 }
 	 
	 addComponent(element, init, index)
	 {
		 // preview mode
		 if (this.preview && element.isPhoto && !element.content)
			 return;
 
		 if (this.sliceText)
			 index = this.getChildIndex(this.sliceText) - 1;
			 
		if (this.pagination.length>0)
			 index = this.getChildIndex(this.pagination[0]);

		 this.maxLevel + 1;
		 
		 if (this.visibleSurface) // add only component from side
		 {
			 if (element.isBackground)
			 {
				 if (this.displayedSide == "left")
				 {
					 if (element.creation == "right")
						 return;
				 }
				 else
				 if (this.displayedSide == "right" )
				 {
					 if (element.creation == "left")
						 return;
				 }
			 }
			 else
			 {
				 let bounding = fx.graphics.getBoundingRect(element, element.rotation);
 
				 if (bounding.x + bounding.width < this.visibleSurface.x ||
					 bounding.x > this.visibleSurface.x + this.visibleSurface.width )
					 return;
			 }
		 }
 
		 let component = this._factory.create(element, this.model, this, !init);
		 if (component)
		 {
			 component.single = this.single;
			 component.preview = this.preview;
			 this.addChild( component, undefined, undefined, index );
			
			 if (!init)
				 this.trigger("component-added", {component : component});
			 
			 if (component instanceof shared.stage.components.Pagination)
			 {
				component.setPosition(this.realWidth, this.realHeight);	// set pagination position according to stage dimensions
			 }
		 }
 
		 return component;
	 }
 
	 
	 /********************* Overrides **********************/
 
     get data()
	 {
		 return super.data;
	 }
 
	 set data(val)
	 {
		 if (this.data)
			 this.listenUpdates( this.data.components, false );
 
		 super.data = val;
 
		 if (this.data)
			 this.listenUpdates( this.data.components, true );
	 }


	 onDataEvent(event)
	 {
		 super.onDataEvent(event);
		
		 if (event.type == "select") // TODO : is this still used
		 {
			 let component = this.getChildFromData( event.model );
			 this.trigger("component-added", {component : component});
		 }
	 }
 
	 onDataUpdated(action)
	 {
		 if (action.type == "addItem" || action.type == "addItemAt")
		 {
			 if (!this.loaded) return;
 
			 for (let i = 0; i < action.items.length; i++)
				 this.addComponent(action.items[i], action.history, action.index);
			 
             this._updateCommands();
		 }
         else
         if (action.impacts("number"))
         {
            if (this.data.hasbackcover)
            {
                if (this.data.isFirstPage) // left
                {
                    for (let i = 0; i < this.backgrounds.length; i++)
                        if (this.backgrounds[i].data.creation == "left")
                            this.backgrounds[i].hide();
                        else
                        this.backgrounds[i].show();
                }
                else
                {
                    for (let i = 0; i < this.backgrounds.length; i++)
                        if (this.backgrounds[i].data.creation == "right")
                            this.backgrounds[i].hide();
                        else
                        this.backgrounds[i].show();
                }
            }
            else
            {
                for (let i = 0; i < this.backgrounds.length; i++)
                    this.backgrounds[i].show();
            }
        }
 
	 }
 
	 onChildUpdated(action)
	 {
		 super.onChildUpdated(action)
 
		 if (action.tag == "update-level-up" || action.tag == "update-level-down")
         {
            this._sortChilds();
            this._updateCommands();
         }

		 // Let's check case when component is moved outside of area, so we delete it
		 if (action.tag == "move-end" || action.tag == "resize-end")
		 {
			 if (!action.model.isBackground)
			 {
				 let bounding = fx.graphics.getBoundingRect(action.model, action.model.rotation);
			 
				 let verticalCondition = (bounding.y >= this._realHeight || bounding.y + bounding.height <= 0);
 
				 let backcoverRight, backcoverLeft, noBackcover;
 
				 // single == true when we use stage to display only one one page
				 // used for now only in Config Application in order to create ThemeLayout
				 if (this.single)
				 {
					 backcoverRight = false;
					 backcoverLeft = false;
					 noBackcover = (bounding.x >= this._realWidth || bounding.x + bounding.width <= 0); 
				 }
				 else
				 {
					 backcoverRight = this.data.isFirstPage && (bounding.x + bounding.width <= this._realWidth/2 || bounding.x >= this._realWidth );
					 backcoverLeft = this.data.isLastPage && ( bounding.x + bounding.width <= 0 || bounding.x  >= this._realWidth/2  );
					 noBackcover = !this.data.hasbackcover && (bounding.x >= this._realWidth || bounding.x + bounding.width <= 0); 
				 }
				 
				 if( verticalCondition || backcoverRight || backcoverLeft || noBackcover )
					 action.model.delete();
			 }
		 }	 
	 }
 

     getElement(id)
     {
        return this.getChild( id );
     }

     
     // ----------------- Private ---------------//
     _sortChilds()
     {
             // this case if for cover displayed in 2 parts
             if (!this.loaded || !this.data || !this.data.components) return;
 
             let components = this.data.sortedComponents;
 
             for (let i = 0; i < components.length; i++)
             {
                 let component = components.getItemAt(i);
 
                 if (component.isBackground)
                     continue;
 
                 let child = this.getChildFromData( component );
 
                 if (child) // we test if child exist in case of cover displaying only one side
                     this.node.removeChild( child.node );
             }

 
             for (let i = 0; i < components.length; i++)
             {
                 let component = components.getItemAt(i);
 
                 if (component.isBackground)
                     continue;
 
                 let child = this.getChildFromData( component );
 
                 if (child)
                     this.node.appendChild( child.node );
             }
 
         if(this.pagination.length>0)
         {
             for(var i=0; i<this.pagination.length; i++)
             {
                 this.node.removeChild( this.pagination[i].node );
                 this.node.appendChild( this.pagination[i].node );
             }
         }
     }
	 
     _updateCommands()
     {
         if (!this.data || !this.data.components) return;
 
         let min = Number.MAX_VALUE, max = 0;
 
         let components = this.data.sortedComponents;
         
         for (let i = 0; i < components.length; i++)
         {
             let component = components.getItemAt(i);
             if (!component) continue;
 
             if (component.isBackground || component.isSliceText) continue;
 
             min = Math.min(component.level, min);
             max = Math.max(component.level , max);
         }
 
         for (let i = 0; i < components.length; i++)
         {
             let component = components.getItemAt(i);
             if (!component) continue;
             
             if (component.isBackground || component.isSliceText) 
                 continue;
 
             let child = this.getChildFromData( component );
             if (child)
             {
                 child.command("senddown", "disabled", component.level == min);
                 child.command("sendup", "disabled", component.level == max);
             }
         }
     }

	

	 
 
 });